module.exports = __webpack_public_path__ + "f52f4cdd09344f3ef65478f91714e667.jpg";